module.exports = __webpack_public_path__ + "img/red-carats.5dbcc2d7.svg";